<div class="container bulk-btn">
  <mat-card
    ><div>
      <mat-form-field appearance="fill">
        <mat-label>{{
          "PAYMENT_HUB.BATCHES.CHOOSE_OPTION" | translate
        }}</mat-label>
        <mat-select [formControl]="template" multiple>
          <mat-option
            *ngFor="let templateItem of templates"
            [value]="templateItem"
            >{{ templateItem }}</mat-option
          >
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" class="bulk-download-btn">
        {{ "PAYMENT_HUB.BATCHES.DOWNLOAD_CSV_TEMPLATE" | translate }}
      </button>
    </div></mat-card
  >
  <mat-card
    ><div class="form-group">
      <label>{{ "PAYMENT_HUB.BATCHES.UPLOAD_BATCH_FILE" | translate }}</label>
      <input
        type="file"
        class="file-input"
        (change)="onFileSelected($event)"
        #fileUpload
      />

      <div class="file-upload">
        {{ fileName || ("PAYMENT_HUB.BATCHES.NO_FILE_UPLOADED" | translate) }}

        <button
          mat-mini-fab
          color="primary"
          class="upload-btn"
          (click)="fileUpload.click()"
        >
          {{ "PAYMENT_HUB.BATCHES.UPLOAD_FILE" | translate }}
          <mat-icon>attach_file</mat-icon>
        </button>
      </div>
    </div></mat-card
  >
</div>

<div class="container">
  <mat-card-title>{{ "PAYMENT_HUB.BATCHES.TITLE" | translate }}</mat-card-title>
</div>
<button (click)="getPosts()" class="hidden">GetPosts</button>
<div class="container">
  <table
    mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z8 demo-table get-batches-table"
  >
    <!-- Position Column -->
    <ng-container matColumnDef="Batch Id">
      <th mat-header-cell *matHeaderCellDef>
        {{ "PAYMENT_HUB.BATCHES.BATCH_ID" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <form class="batch-summary-wrap" #batchSummaryForm="ngForm">
          <mat-form-field class="example-full-width hidden" appearance="fill">
            <mat-label hidden>Enter Batch ID</mat-label>
            <input
              matInput
              class="form-control col-sm-4 batch-summary-id"
              ngModel="{{ element.batchId }}"
              name="batchid"
              id="batch-id"
              hidden
            />
          </mat-form-field>

          <button
            color=""
            type="submit"
            [disabled]="!batchSummaryForm.valid"
            [value]="element.batchId"
            (click)="getBatchSummaryinfo($event.target.value)"
          >
            {{ element.batchId }}
          </button>
        </form>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="Request Id">
      <th mat-header-cell *matHeaderCellDef>
        {{ "PAYMENT_HUB.BATCHES.REQUEST_ID" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.requestId }}</td>
    </ng-container>
    <ng-container matColumnDef="Completed">
      <th mat-header-cell *matHeaderCellDef>
        {{ "PAYMENT_HUB.BATCHES.COMPLETED" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.completed }}</td>
    </ng-container>
    <ng-container matColumnDef="Completion Time">
      <th mat-header-cell *matHeaderCellDef>
        {{ "PAYMENT_HUB.BATCHES.COMPLETION_TIME" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ formatDate(element.completedAt) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Failed">
      <th mat-header-cell *matHeaderCellDef>
        {{ "PAYMENT_HUB.BATCHES.FAILED" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.failed }}</td>
    </ng-container>
    <ng-container matColumnDef="Total">
      <th mat-header-cell *matHeaderCellDef>
        {{ "PAYMENT_HUB.BATCHES.TOTAL" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.totalTransactions }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    #paginator
    [pageSizeOptions]="[50, 100, 200]"
    showFirstLastButtons
    aria-label="Select page of periodic elements"
    [length]="lengthGetBatches"
    [pageSize]=""
  >
  </mat-paginator>
</div>
